<template>
  <div>
    <div class="mb-4">
      <p class="my-2">
        Terimakasih karena telah mendaftarkan diri pada situs SAPBKPP. Sebelum dapat menginputkan
        biodata mahasiswa dan melakukan proses pengajuan beasiswa, anda perlu melakukan verifikasi terhadap
        email yang digunakan untuk mendaftar.
      </p>
      <p class="my-2">
        Silahkan cek link yang kami kirimkan pada email yang di gunakan untuk mendaftar termasuk
        folder inbox atau spam.
      </p>
      <p class="my-2">
        Jika terjadi masalah sehingga email konfirmasi tidak diterima, silahkan proses pengiriman
        ulang email konfirmasi melalui tombol dibawah ini.
      </p>
    </div>
    <form @submit.prevent="submit">
      <div class="flex justify-between items-center mt-4">
        <loading-button
          :loading="form.processing"
          class="btn-indigo"
          type="submit">
          Kirim Email
          Verifikasi
        </loading-button>
      </div>
    </form>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'

export default {
    layout: Layout,
    metaInfo: { title: 'Dashboard' },
    components: {
        LoadingButton,
    },

    data () {
        return {
            form: this.$inertia.form({}),
        }
    },
    methods: {
        submit () {
            this.form.post(this.route('verification.resend'))
        },
    },
}
</script>
